import { useUpdateWindowType, usePageViewEvent } from 'common/hooks';

export const useRoughWorkPage = () => {
	useUpdateWindowType();
	usePageViewEvent();
};
